module.exports = __webpack_public_path__ + "img/pie.1c42ecfb.jpg";